const patientDetailsDrawerBody = {
  // Chrome copy for the shared presentational drawer shell. The drawer is
  // titled "Patient quick-look" across all surfaces (matches Figma); the
  // loading/error/empty copy is reused by every data wrapper (clinic, admin).
  drawer: {
    title: "Patient quick-look",
    loadingLabel: "Loading patient details",
    loadError: "We couldn't load patient details. Please try again.",
    emptyState: "No patient details found.",
  },
  sectionTitles: {
    biometrics: "Biometrics",
    patientSurveys: "Patient Surveys",
    goals: "Goals",
    conditions: "Conditions",
    symptoms: "Symptoms",
    currentlyTaking: "Currently taking",
    medications: "Medications",
    womensHormones: "Women's hormones",
  },
  womensHormones: {
    menopauseStatus: "Current menopause status",
    periodStatus: "Current period status",
    appointmentDate: "Appointment date",
    menstrualCyclePhase: "Menstrual cycle phase",
    suggestedDates: "Suggested test dates",
  },
  viewSurveysButton: "View surveys",
  emptyDemographicsFallback: "No demographics provided",
  emptyCurrentlyTakingDetailsFallback: "No brand or dosage provided",
} as const;

export { patientDetailsDrawerBody };
